export default __webpack_public_path__ + "static/merge-dialog-8b9a0101b88b1eba0bcc7ab0d345ec29.png";